import type { BuildingStructuralMaterialsSections } from "../../../types/buildings-sections/structural-materials";

export const structuralMaterials: BuildingStructuralMaterialsSections = {
  title: "Structural Materials",
  description: "Building structural materials and components management",
  noDataAvailable: "Structural materials data not available",
  material: "Material",
  details: "Details",
  specifications: "Specifications",
  manufacturer: "Manufacturer",
  installationDate: "Installation Date",
};
